import * as Types from '../../generated/types';

import gql from 'graphql-tag';
import * as Urql from '@/urql/urqlWrapper';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type IKycContextQueryVariables = Types.Exact<{
  applicationInput?: Types.InputMaybe<Types.IGetApplicationInput>;
}>;


export type IKycContextQuery = { __typename?: 'Query', getApplication: { __typename?: 'GetApplicationResponse', application?: { __typename?: 'Application', id: string, status: Types.IApplicationStatus, documents: Array<{ __typename?: 'ApplicationDocument', id: string, status: Types.IApplicationDocumentStatus, documentType: Types.IApplicationDocumentType, description: string, name: string, dateOfBirth?: Date | null, passport?: string | null, ein?: string | null, reasonCode?: Types.IApplicationDocumentReasonCode | null, reason?: string | null, address?: { __typename?: 'Address', street: string, street2?: string | null, city: string, state?: string | null, postalCode?: string | null, countryCode: string } | null }> } | null, errors?: Array<{ __typename?: 'DefaultError', message: string, stackTrace?: string | null }> | null } };

export type IKycContextApplicationFragment = { __typename?: 'Application', id: string, status: Types.IApplicationStatus, documents: Array<{ __typename?: 'ApplicationDocument', id: string, status: Types.IApplicationDocumentStatus, documentType: Types.IApplicationDocumentType, description: string, name: string, dateOfBirth?: Date | null, passport?: string | null, ein?: string | null, reasonCode?: Types.IApplicationDocumentReasonCode | null, reason?: string | null, address?: { __typename?: 'Address', street: string, street2?: string | null, city: string, state?: string | null, postalCode?: string | null, countryCode: string } | null }> };

export type IKycContextApplicationDocumentFragment = { __typename?: 'ApplicationDocument', id: string, status: Types.IApplicationDocumentStatus, documentType: Types.IApplicationDocumentType, description: string, name: string, dateOfBirth?: Date | null, passport?: string | null, ein?: string | null, reasonCode?: Types.IApplicationDocumentReasonCode | null, reason?: string | null, address?: { __typename?: 'Address', street: string, street2?: string | null, city: string, state?: string | null, postalCode?: string | null, countryCode: string } | null };

export const KycContextApplicationDocumentFragmentDoc = gql`
    fragment KycContextApplicationDocument on ApplicationDocument {
  id
  status
  documentType
  description
  name
  address {
    street
    street2
    city
    state
    postalCode
    countryCode
  }
  dateOfBirth
  passport
  ein
  reasonCode
  reason
}
    `;
export const KycContextApplicationFragmentDoc = gql`
    fragment KycContextApplication on Application {
  id
  status
  documents {
    ...KycContextApplicationDocument
  }
}
    ${KycContextApplicationDocumentFragmentDoc}`;
export const KycContextDocument = gql`
    query KycContext($applicationInput: GetApplicationInput) {
  getApplication(input: $applicationInput) {
    application {
      ...KycContextApplication
    }
    errors {
      message
      stackTrace
    }
  }
}
    ${KycContextApplicationFragmentDoc}`;

export function useKycContextQuery(options?: Omit<Urql.UseQueryArgs<IKycContextQueryVariables>, 'query'>) {
  return Urql.useQuery<IKycContextQuery, IKycContextQueryVariables>({ query: KycContextDocument, ...options });
};